"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function assertType(obj, key, type = 'string') {
    if (!obj[key] || typeof obj[key] !== type) {
        throw new Error(`Missing or invalid "${key}" param`);
    }
}
exports.assertType = assertType;
function hasParamsLength(params, length) {
    return Array.isArray(params)
        ? params.length === length
        : Object.keys(params).length === length;
}
exports.hasParamsLength = hasParamsLength;
function methodEndsWith(method, expected, separator = '_') {
    const split = method.split(separator);
    return (split[split.length - 1].trim().toLowerCase() ===
        expected.trim().toLowerCase());
}
exports.methodEndsWith = methodEndsWith;
//# sourceMappingURL=misc.js.map